
// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "./BaseButton";
import UIButton from "../../components/core/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnHomePause extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 80.5, y ?? 80.5);

    // btn_endscreen_png
    const btn_endscreen_png = scene.add.image(0, 0, "endscreen", "popup-btn-middle.png");
    this.add(btn_endscreen_png);

    // icon_popuppause_home
    const icon_popuppause_home = scene.add.image(0, -11, "endscreen", "popup-icon-home.png");
    this.add(icon_popuppause_home);

    // this (components)
    new UIButton(this);

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
